export default "__VITE_ASSET__aVk2WWtu__"